<template>
<div class="chapter">
<div class="inner_page">
<h2 class="pn"><a id="page_1"></a><a id="part01"></a><strong>Section 1</strong></h2>
<h2 class="pt"><strong>BEFORE YOU WRITE</strong></h2>
<p class="image"><img alt="image" src="images/book.jpg"/><a id="page_2"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?d433d7d0